import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Input, Menu } from "semantic-ui-react";
import Dls from '../../lib';

class TopMenuComponent extends Component {
    doSearch = () => {

    }
    
    render() {
        return (
            <div className="menu">
                <Menu fixed="top" className="top-menu">
                    <Menu.Item className="logo-space-menu-item">
                        <div className="display-inline logo-space">
                            <p />
                        </div>
                    </Menu.Item>

                    {!this.props.mobile ? <Menu.Item
                        className="no-border"
                        onClick={() => this.props.toggleSidebar()}
                    >
                        <Icon name="bars" />
                    </Menu.Item> : null}

                    {this.props.mobile ? <Menu.Item
                        className="no-border"
                        onClick={() => this.props.history.push('/')}
                    >
                        <Icon name="computer" />
                    </Menu.Item> : <Menu.Item
                        className="no-border"
                        onClick={() => this.props.history.push(`/mobile/customer-orders/${Dls.pagination.orders('Customer Order')}`)}
                    >
                        <Icon name="mobile alternate" />
                    </Menu.Item>}

                    {/* <Menu.Item className="no-border drop-left-padding">
                        <Input
                            className="icon"
                            icon="search"
                            placeholder="Search..."
                            onChange={this.doSearch.bind(this)}
                        />
                    </Menu.Item> */}

                    <Menu.Menu position="right">
                        <Menu.Item
                            className="no-border"
                            position="right"
                        >
                            <div className="display-inline">
                                {this.props.userName}
                            </div>
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </div>
        )
    }
}

TopMenuComponent.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
     }).isRequired,
    toggleSidebar: PropTypes.func,
    userName: PropTypes.string,
    mobile:PropTypes.bool.isRequired
};

export default TopMenuComponent


// WEBPACK FOOTER //
// ./src/routes/parts/TopMenu.js